import { locale } from './globals.js';

let htmlBuffer = document.createElement('div');

class AutoPopup {
  constructor(el) {
    if(!el) return false
    this.el = el
    this.delay = this.el.getAttribute('data-delay') || 1500
    setTimeout(() => {
      this.open()
    }, this.delay)
  }
  open() {
    let url = this.el.getAttribute('data-url')
    let target = this.el.getAttribute('data-target') || '_self'
    this.popupInstance = $.fancybox.open({
      src: this.el.getAttribute('data-src'),
      opts: {
        baseClass: this.el.getAttribute('data-class'),
        buttons: [
          "close"
        ],
        video: {
          tpl:
            `<div class="fancybox-content">
              <div class="media stretch" data-media>
                <video class="fancybox-video" muted controlsList="nodownload" poster="{{poster}}">
                  <source src="{{src}}" type="{{format}}" />
                  Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!
                </video>
                <div class="play-icon"><i class="fas fa-play"></i></div>
              </div>
            </div>`,
          format: "", // custom video format
          autoStart: true
        },
        clickContent: function(current, event) {
          return false;
        },
        afterShow: function(instance, slide) {
          let media = slide.$content[0].querySelector('[data-media]')
          let video = slide.$content[0].querySelector('video')
          if (!url) return
          slide.$content[0].addEventListener('click', (event) => {
            let state = media.getAttribute('data-state') 
            // if (video.currentTime > 0.005 || video.ended) {
            if (state == 'playback' || state == 'ended') {
              window.open(url, target);
              requestAnimationFrame(() => {
                if(video.paused && !video.ended)
                  video.play()
              })
            }
          })
        }
      }
    });
  }

}
new AutoPopup(document.querySelector('[data-auto-popup]'))

